import classNames from 'classnames';
import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ConnectedHelpCenter } from 'components/shared/HelpCenter/HelpCenter';
import { ConnectedUserPreferencesButton } from 'components/userPreferences';
import { useIsAnyRouteActive } from 'hooks/use-is-any-route-active';
import { useToggleFeature } from 'hooks/useToggleFeature';
import { ConnectedAccountCenter } from 'layouts/main/sp-header/accountCenter';
import { LaptopNavigation } from 'layouts/main/sp-header/navigation/laptop-navigation';
import { MobileNavigation } from 'layouts/main/sp-header/navigation/MobileNavigation';
import { useIntl } from 'react-intl';

import { SocGenLogo } from './SocGenLogo';

export function AppHeader(): React.JSX.Element {
  const { formatMessage } = useIntl();
  const helpRequestHeaderReplacement = useToggleFeature('helpRequestHeaderReplacement');
  const isEssentialWorkspaceEnabled = useToggleFeature('essentialWorkspaceParis');
  const hasBorder = useIsAnyRouteActive('/essential', '/smart-quote');

  return (
    <nav
      className={classNames(`navbar bg-lvl1 sticky-top`, {
        ' navbar-sm': isEssentialWorkspaceEnabled,
        ' border-bottom border-opacity-70': hasBorder && isEssentialWorkspaceEnabled,
      })}
    >
      <div className="navbar-title">
        <SocGenLogo />
        <MobileNavigation />
      </div>
      <LaptopNavigation />
      <div className="navbar-toolbar">
        <div className="life-ring" data-e2e="HelpRequest-button">
          {!helpRequestHeaderReplacement && (
            <LifeRingTrigger e2e="LifeRing-button">
              <button aria-expanded="true" className="btn btn-lg btn-icon btn-flat-primary" role="button">
                <i className="icon" title={formatMessage({ id: 'lifeRing.helpRequest' })}>
                  live_help
                </i>
              </button>
            </LifeRingTrigger>
          )}
        </div>
        <ConnectedUserPreferencesButton />
        <ConnectedAccountCenter />
        <ConnectedHelpCenter />
      </div>
    </nav>
  );
}

AppHeader.displayName = 'RawAppHeader';
